import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';

import WinnerActions from '../winner-actions';

const initialState = Immutable({
  winnerHistorysById: {},
});

const reducer = createReducer((on) => {
  on(WinnerActions.fetchWinnersHistorySuccess, (state, { winnerHistorys }) => {
    const winnerHistorysById = _.reduce(
      winnerHistorys,
      (accHistory, history) => {
        accHistory[history.id] = history;
        return accHistory;
      },
      {}
    );
    return state.set('winnerHistorysById', winnerHistorysById);
  });
}, initialState);

export default reducer;
